import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Désolé, la page que vous recherchez n'existe pas."
      extra={
        <Button type="primary" onClick={() => navigate(-1)}>
          Retourner{" "}
        </Button>
      }
    />
  );
}

export default NotFound;
